import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [{
    path: '/'
  }, {
    path: '/etape/:etape'
  }]
})



// WEBPACK FOOTER //
// ./src/router.js